import { atom } from "recoil"
import decode from 'jwt-decode'

const localStorageEffect = key => ({ setSelf, onSet }) => {
  const token = localStorage.getItem(key)
  if (token) {
    const { loginName, firstName, userId, roles } = decode(token)
    setSelf({
      userId,
      loginName,
      firstName,
      roles
    })
  }

  onSet((newValue) => {
    const { token } = newValue
    if (!token)
      return
      
    localStorage.setItem(key, token)
  })
}

export const userState = atom({
  key: "userState",
  default: {
    userId: -1,
    firstName: '',
    loginName: '',
    roles: ''
  },
  effects_UNSTABLE: [
    localStorageEffect('token'),
  ],
})